import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { XIcon, FacebookIcon, WhatsAppIcon } from 'app/commonComponents/icons';
import { colors } from 'app/variables';
import view from 'modules/ticketPublicPage/stores/tickets/view';
import { ShareContainer, ShareIcons, SocialIcon } from './ShareGroup.styles';

const SocialIconButton = ({ onShare, ariaLabel, children }) => (
  <SocialIcon
    aria-label={ariaLabel}
    onClick={onShare}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        onShare();
      }
    }}
    style={{ color: colors.pacificBlue }}
  >
    {children}
  </SocialIcon>
);

SocialIconButton.propTypes = {
  onShare: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const ShareGroup = observer(() => {
  const {
    name,
    has_expired: hasExpired,
    status,
    public_page_url: publicPageUrl,
    tickets_remained: ticketsRemained,
    min_purchases: minPurchases,
  } = view.activeObject;

  const hasAvailableTickets =
    status === 'active' &&
    view.available &&
    !hasExpired &&
    ticketsRemained >= minPurchases;

  if (!hasAvailableTickets) return;

  return (
    <ShareContainer>
      <ShareIcons>
        <SocialIconButton
          ariaLabel={i18n.gettext('Share on X')}
          onShare={() =>
            window.open(
              `http://twitter.com/share?url=${publicPageUrl}&amp;text=${name}`
            )
          }
        >
          <XIcon xsmall />
        </SocialIconButton>
        <SocialIconButton
          ariaLabel={i18n.gettext('Share on facebook')}
          onShare={() =>
            window.open(
              `https://www.facebook.com/sharer/sharer.php?u=${publicPageUrl}`
            )
          }
        >
          <FacebookIcon xsmall />
        </SocialIconButton>
        <SocialIconButton
          ariaLabel={i18n.gettext('Share via whatsapp')}
          onShare={() => window.open(`https://wa.me/?text=${publicPageUrl}`)}
        >
          <WhatsAppIcon xsmall />
        </SocialIconButton>
      </ShareIcons>
    </ShareContainer>
  );
});

export default ShareGroup;
